import { render, staticRenderFns } from "./ask-support.vue?vue&type=template&id=4da919d4"
import script from "./ask-support.vue?vue&type=script&lang=js"
export * from "./ask-support.vue?vue&type=script&lang=js"
import style0 from "./ask-support.vue?vue&type=style&index=0&id=4da919d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports